import { RepositoryError } from './RepositoryError';
export class ValidationError extends RepositoryError {
    fields;
    constructor(message, fields, options) {
        super(message, options);
        this.name = 'ValidationError';
        this.fields = fields;
    }
    get allMessages() {
        return Object.values(this.fields).flatMap((messages) => [...messages]);
    }
}
